// import qs from 'qs'
import axios from 'axios'

export const screenLoadingService = ({
  listAllScreensLoading (token) {
    return axios.get('/api/LoadingAssetMetaData', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleFile (token, fileId) {
    return axios.get('/api/filerepository/single?fileId=' + fileId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createScreenLoading (token, formDataObj) {
    return axios.post('/api/LoadingAssetMetaData/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateScreenLoading (token, formDataObj) {
    return axios.put('/api/LoadingAssetMetaData/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteScreenLoading (token, loadingAssetMetaDataId) {
    return axios.delete('/api/LoadingAssetMetaData/Delete?loadingAssetMetaDataId=' + loadingAssetMetaDataId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/screen-loading-services.js